import { createHandlerChainRunnerOptionalParameter, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { WarehouseModal } from "@NA/Services/ADIGetInventory";
import { getInventoryPuddles, InventoryPuddlesParams, Puddle, WarehousePuddleModal } from "@NA/Services/ADIGetInventoryPuddles";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface InventoryPuddlesParam {
    productId?: string;
    postalCode?: string;
}

type HandlerType = CustomApiHandler<InventoryPuddlesParams & HasOnSuccess & HasOnError, WarehousePuddleModal>;

export const DispatchBeginLoadInventoryPuddles: HandlerType = props => {
    props.dispatch({
        type: "Custom/BeginLoadInventoryPuddles",
        parameter: props.parameter,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getInventoryPuddles({productId: props.apiParameter.productId, postalCode: props.apiParameter.postalCode, IsLbIndicator: props.apiParameter.IsLbIndicator, IsLBInonSplOrd: props.apiParameter.IsLBInonSplOrd});
};

export const DispatchCompleteLoadInventoryPuddles: HandlerType = props => {
    if (props.apiResult) {
        props.parameter.onSuccess?.(props.apiResult as any);
        props.dispatch({
            type: "Custom/CompleteLoadInventoryPuddles",
            InventoryPuddlesData: props.apiResult
        });
    }
};

export const chain = [DispatchBeginLoadInventoryPuddles, PopulateApiParameter, RequestDataFromApi, DispatchCompleteLoadInventoryPuddles];

const LoadInventoryPuddles = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        productId: "",
        postalCode: "",
        IsLbIndicator: "",
        IsLBInonSplOrd: "",
    },
    "LoadInventoryPuddles",
);
export default LoadInventoryPuddles;